var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "form-group" }, [
        _vm.sectionProductionDate
          ? _c("label", { staticClass: "col-md-2 control-label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.trans(
                      "production_reports.production_list.production_date"
                    )
                  ) +
                  "\n          "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.sectionDeliveryDate
          ? _c("label", { staticClass: "col-md-2 control-label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.trans(
                      "production_reports.production_list.delivery_date"
                    )
                  ) +
                  "\n          "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-1 pr-0" },
          [
            _c("single-select", {
              attrs: {
                options: _vm.productCategories,
                "allow-empty": false,
                disabled: _vm.disabled,
                placeholder: _vm._f("trans")(
                  "purchase_order.material.product_categories"
                )
              },
              model: {
                value: _vm.internalValue.productCategory,
                callback: function($$v) {
                  _vm.$set(_vm.internalValue, "productCategory", $$v)
                },
                expression: "internalValue.productCategory"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.showDeliveryDate
          ? _c(
              "div",
              { staticClass: "col-md-1 pr-0" },
              [
                _c("date-picker", {
                  attrs: {
                    time: false,
                    "init-value": false,
                    disabled: _vm.disabled,
                    "can-clear": "",
                    placeholder: _vm._f("trans")(
                      "purchase_order.material.delivery_date_from"
                    )
                  },
                  model: {
                    value: _vm.internalValue.deliveryDateFrom,
                    callback: function($$v) {
                      _vm.$set(_vm.internalValue, "deliveryDateFrom", $$v)
                    },
                    expression: "internalValue.deliveryDateFrom"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showDeliveryDate
          ? _c(
              "div",
              { staticClass: "col-md-1 pr-0" },
              [
                _c("date-picker", {
                  attrs: {
                    time: false,
                    "init-value": false,
                    disabled: _vm.disabled,
                    "can-clear": "",
                    placeholder: _vm._f("trans")(
                      "purchase_order.material.delivery_date_to"
                    )
                  },
                  model: {
                    value: _vm.internalValue.deliveryDateTo,
                    callback: function($$v) {
                      _vm.$set(_vm.internalValue, "deliveryDateTo", $$v)
                    },
                    expression: "internalValue.deliveryDateTo"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showProductionDate
          ? _c(
              "div",
              { staticClass: "col-md-1 pr-0" },
              [
                _c("date-picker", {
                  attrs: {
                    time: false,
                    "init-value": false,
                    disabled: _vm.disabled,
                    "can-clear": "",
                    placeholder: _vm._f("trans")(
                      "purchase_order.material.production_date_from"
                    )
                  },
                  model: {
                    value: _vm.internalValue.productionDateFrom,
                    callback: function($$v) {
                      _vm.$set(_vm.internalValue, "productionDateFrom", $$v)
                    },
                    expression: "internalValue.productionDateFrom"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showProductionDate
          ? _c(
              "div",
              { staticClass: "col-md-1 pl-10 pr-0" },
              [
                _c("date-picker", {
                  attrs: {
                    time: false,
                    "init-value": false,
                    disabled: _vm.disabled,
                    "can-clear": "",
                    placeholder: _vm._f("trans")(
                      "purchase_order.material.production_date_to"
                    )
                  },
                  model: {
                    value: _vm.internalValue.productionDateTo,
                    callback: function($$v) {
                      _vm.$set(_vm.internalValue, "productionDateTo", $$v)
                    },
                    expression: "internalValue.productionDateTo"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 pl-10 pr-0" },
          [
            _c("multi-select", {
              attrs: {
                checked: _vm.internalValue.teams,
                disabled: _vm.disabled,
                options: _vm.teams,
                placeholder: _vm._f("trans")("purchase_order.material.teams")
              },
              model: {
                value: _vm.internalValue.teams,
                callback: function($$v) {
                  _vm.$set(_vm.internalValue, "teams", $$v)
                },
                expression: "internalValue.teams"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 pl-10 pr-0" },
          [
            _c("multi-select", {
              attrs: {
                checked: _vm.internalValue.brands,
                disabled: _vm.disabled,
                options: _vm.brands,
                placeholder: _vm._f("trans")("purchase_order.material.brands")
              },
              model: {
                value: _vm.internalValue.brands,
                callback: function($$v) {
                  _vm.$set(_vm.internalValue, "brands", $$v)
                },
                expression: "internalValue.brands"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 pl-10 production-row-buttons" }, [
          _vm.internalValue.isValid
            ? _c("i", {
                staticClass: "fa fa-check-circle text-success font-lg"
              })
            : _c("i", {
                staticClass: "fa fa-minus-circle text-danger font-lg",
                attrs: {
                  title: _vm._f("trans")("offer.import.exceptions.invalid_date")
                }
              }),
          _vm._v(" "),
          _vm.canAdd
            ? _c("button", {
                staticClass: "btn btn-primary fa fa-plus",
                attrs: {
                  title: _vm._f("trans")("grid.add_record"),
                  disabled: _vm.disabled
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("add")
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.canDelete
            ? _c("button", {
                staticClass: "btn btn-danger fa fa-trash",
                attrs: {
                  title: _vm._f("trans")("grid.remove"),
                  disabled: _vm.disabled
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("delete")
                  }
                }
              })
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87830004", { render: render, staticRenderFns: staticRenderFns })
  }
}